import { inject } from 'vue';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import { $tools } from './tools';
import { $g } from './global';
import { $cookie } from './cookie';
import { api } from './api';
import { $request } from './request';
import { useStore } from 'vuex';
import { layout } from '../store/layout';
import { passport } from '../store/passport';
import { mutations } from './../store/types';
import { message } from 'ant-design-vue';
import NProgress from 'nprogress';
let _init = false;
export default {
    created() {
        if (!_init) {
            const store = useStore();
            const router = useRouter();
            const route = useRoute();
            const { locale, t } = useI18n();
            const i18n = inject('$i18n');
            $tools.setTitle();
            $tools.setKeywords();
            $tools.setDescription();
            $cookie.set($g.caches.cookies.theme, $g.theme.active);
            try {
                store.registerModule(['layout'], layout);
                store.registerModule(['passport'], passport);
            }
            catch (e) {
                throw new Error('[vuex] must be required. Please install and import [vuex] before makeit-admin-pro\r\n' +
                    e);
            }
            $g.isMobile = $tools.isMobile();
            store.commit(`layout/${mutations.layout.mobile}`);
            window.onresize = () => {
                $g.isMobile = $tools.isMobile();
                store.commit(`layout/${mutations.layout.mobile}`);
            };
            const redirect = () => {
                store.commit(`passport/${mutations.passport.reset}`);
                router.push({
                    path: '/login'
                });
            };
            axios.interceptors.request.use((config) => {
                const token = $cookie.get($g.caches.cookies.token.access);
                if (token)
                    config.headers.Authorization = `Bearer ${token}`;
                return config;
            }, (err) => {
                return Promise.reject(err);
            });
            let regranting = false;
            axios.interceptors.response.use((response) => {
                return response;
            }, async (err) => {
                const resend = () => {
                    const config = err.config;
                    const method = config.method.toLowerCase();
                    return $request[method](config.url, method === 'get' ? config.params : config.data, {
                        retry: config.retry,
                        retryCount: config.retryCount
                    });
                };
                if (err.response.status === 401) {
                    if (!regranting) {
                        regranting = true;
                        const refreshToken = $cookie.get($g.caches.cookies.token.refresh);
                        if (!$tools.isEmpty(refreshToken)) {
                            store
                                .dispatch('passport/refresh', { refresh_token: refreshToken })
                                .then((res) => {
                                regranting = false;
                                if (res?.ret?.code === 200)
                                    return resend();
                                else {
                                    message.error(t('auth'));
                                    redirect();
                                }
                            })
                                .catch(() => {
                                regranting = false;
                            });
                        }
                        else {
                            regranting = false;
                            message.error(t('auth'));
                            redirect();
                        }
                    }
                }
                else {
                    const config = err.config;
                    if (!config?.retry)
                        return Promise.reject(err.response);
                    if (config.retryCount >= config.retry)
                        return Promise.reject(err.response);
                    config.retryCount += 1;
                    await resend();
                }
            });
            const getLanguage = async () => {
                const token = $cookie.get($g.caches.cookies.token.access);
                if (api.languages.data && token) {
                    return await $request
                        .get(api.languages.data, { type: 'all' }, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then((res) => {
                        if (res?.ret?.code === 200)
                            return res?.data;
                    })
                        .catch((err) => {
                        message.error(err.message);
                    });
                }
            };
            const setCustomizeLanguage = async () => {
                const languages = (await getLanguage()) || [];
                const customize = {};
                for (let i = 0, l = languages.length; i < l; i++) {
                    const language = languages[i];
                    customize[language.key] = language.language;
                }
                if (Object.keys(customize).length > 0)
                    i18n.setLocale(locale.value, customize);
            };
            setCustomizeLanguage();
            NProgress.configure({
                easing: 'ease',
                speed: 1000,
                showSpinner: false,
                trickleSpeed: 200
            });
            router.beforeEach((_to, _from, next) => {
                $tools.back2top(0, 0, () => {
                    NProgress.start();
                    next();
                });
            });
            router.afterEach(() => {
                $tools.setTitle((route?.meta?.title ?? $g.title));
                $tools.setDescription((route?.meta?.description ?? $g.description), true);
                NProgress.done();
            });
            _init = true;
        }
    }
};
